import { FieldModel } from '@models/module/fields/main/fieldModel';
import { FormulaField } from '@module-definition/formulas/cipo-formula/formula.model';

export const DemoFormulaField: FormulaField[] = [
  {
    id: 1,
    label: 'Test 1',
    type: 'string',
    isContractField: true,
  },
  {
    id: 2,
    label: 'Test 2',
    type: 'number',
    isContractField: false,
  },
  {
    id: 3,
    label: 'Test 3',
    type: 'string',
    isContractField: true,
  },
  {
    id: 4,
    label: 'Test 4',
    type: 'date',
    isContractField: true,
  },
  {
    id: 5,
    label: 'Test 5',
    type: 'number',
    isContractField: false,
  },
  {
    id: 6,
    label: 'Test 6',
    type: 'string',
    isContractField: true,
  },
];

export const DemoGetField: FieldModel = {
  id: 2965,
  name: 'Number',
  label: 'Number',
  hasMultipleValues: false,
  defaultValue: null,
  formattings: [],
  restrictions: [],
  entityIds: [],
  screenIds: [],
  inUse: false,
  canDelete: false,
  canRemove: false,
  fieldOrigin: 1,
  isFilter: false,
  useOnReport: false,
  canHaveAggregate: false,
  isContractSystemField: false,
  isSystemField: false,
  currentDateTime: false,
  typeId: 1,
  displayTypeId: 1,
};
